export function treeElementRestructure(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return []; // If data is not an array or is empty, return an empty array
    }

    // Create a lookup table for elements by their Id
    const lookup = {};
    data.forEach(item => {
        lookup[item.element.Id] = { ...item, members: [] };
    });

    // Assign children to their parents
    data.forEach(item => {
        if (item.element.IdParent && lookup[item.element.IdParent]) {
            lookup[item.element.IdParent].members.push(lookup[item.element.Id]);
        }
    });

    // Collect top-level elements (those without a parent)
    const result = data
        .filter(item => !item.element.IdParent)
        .map(item => lookup[item.element.Id]);

    // Clean up members: set to null if empty
    const cleanMembers = (items) => {
        items.forEach(item => {
            if (item.members.length === 0) {
                item.members = null;
            } else {
                cleanMembers(item.members);
            }
        });
    };
    cleanMembers(result);

    return result;
}
